import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { Provider } from "react-redux";

import store from "./lib/core/redux/store";
import { setPalette } from "./lib/functions";

import App from "./App";
import ErrorMessage from "./ErrorMessage";
import { ajaxUri, url } from "./lib/consts/index";

if (document.domain !== "localhost") {
  if (!window.location.href.includes("devgk")) {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }
}
axios({
  method: "post",
  url: ajaxUri,
  data: {
    request: "authenticate",
  },
})
  .then((result) => {
    if (result.data.auth || window.location.hostname === "localhost") {
      axios({
        method: "post",
        url: ajaxUri,
        data: {
          request: "getTranslations",
        },
      })
        .then((result) => {
          let data = {};
          try {
            data = JSON.parse(result.data);
          } catch (err) {
            console.log(err);
          }
          store.dispatch({
            type: "TRANSLATE",
            object: data,
          });

          axios({
            method: "post",
            url: ajaxUri,
            data: {
              request: "listBlocks",
            },
          })
            .then((result) => {
              const tabs = result.data || [];
              tabs.sort((a, b) => a.id.localeCompare(b.id));

              setPalette(tabs);

              const root = document.getElementById("gk-pagebuilder");
              if (root && root.innerHTML !== "")
                ReactDOM.hydrate(
                  <Provider store={store}>
                    <App />
                  </Provider>,
                  root
                );
              else
                ReactDOM.render(
                  <Provider store={store}>
                    <App />
                  </Provider>,
                  root
                );
            })
            .catch((error) => {});
        })
        .catch((error) => {
          console.error("Cannot get translations");
        });
    } else {
      window.location.replace(
        url.protocol + "//" + url.hostname + "/administration"
      );
    }
  })
  .catch((error) => {
    const root = document.getElementById("gk-pagebuilder");
    if (root && root.innerHTML !== "")
      ReactDOM.hydrate(
        <Provider store={store}>
          <ErrorMessage type={1} />
        </Provider>,
        root
      );
    else
      ReactDOM.render(
        <Provider store={store}>
          <ErrorMessage type={1} />
        </Provider>,
        root
      );
  });
